import { render, staticRenderFns } from "./PlansSkeleton.vue?vue&type=template&id=8711bcf2"
import script from "./PlansSkeleton.vue?vue&type=script&lang=js"
export * from "./PlansSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports